import { MESSAGE_SAVE_FAIL, MESSAGE_SAVE_SUCCESS } from 'constants/message';
import { appSlice } from 'modules/app/appSlice';
import React, { RefObject, useState } from 'react';
import { Button } from 'react-native-paper';
import { useDispatch } from 'react-redux';
import shareImage from 'utils/shareImage';
import showAdInterstitial from 'utils/showAdInterstitial';
import takeCapture from 'utils/takeCapture';

type ButtonType = 'save' | 'share';

type ButtonOptions = {
	[key in ButtonType]: {
		label: string;
		icon: string;
	};
};

const BUTTON_OPTIONS: ButtonOptions = {
	save: {
		label: '保存する',
		icon: 'download',
	},
	share: {
		label: 'シェアする',
		icon: 'share',
	},
};

type Props = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	captureTargetRef: RefObject<any>;
	type: ButtonType;
};

const SaveButton: React.VFC<Props> = ({ captureTargetRef, type }) => {
	const [isProcessing, setIsProcessing] = useState<boolean>(false);

	const dispatch = useDispatch();

	const _handleSuccess = (uri?: string) => {
		if (type === 'share') {
			if (typeof uri !== 'undefined') shareImage(uri);
		} else {
			dispatch(appSlice.actions.showMessage(MESSAGE_SAVE_SUCCESS));
		}
		setIsProcessing(false);
	};

	const _handleFail = () => {
		dispatch(appSlice.actions.showMessage(MESSAGE_SAVE_FAIL));
		setIsProcessing(false);
	};

	const handlePress = async () => {
		setIsProcessing(true);
		await showAdInterstitial();
		await takeCapture(captureTargetRef, _handleSuccess, _handleFail);
	};
	return (
		<Button
			onPress={handlePress}
			mode="contained"
			icon={BUTTON_OPTIONS[type]['icon']}
			loading={isProcessing}>
			{BUTTON_OPTIONS[type]['label']}
		</Button>
	);
};

export default SaveButton;
